import PropTypes from "prop-types";
import { useEffect, useState } from "react";
// next
import { useRouter } from "next/router";
// hooks
import useAuth from "src/hooks/useAuth";
// routes
import { PATH_AUTH, PATH_DASHBOARD } from "../routes/paths";
import RecommendScreenSizePopup from "src/components/RecommendScreenSizePopup";
import LoadingScreen from "@/components/LoadingScreen";

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { push } = useRouter();
  const [screenSize, setScreenSize] = useState(getCurrentDimension());
  const [open, setOpen] = useState(false);
  const { isAuthenticated, isOtpVerified } = useAuth();
  function getCurrentDimension(){
    return {
      width:window.innerWidth,
      height:window.innerHeight
    }
 };

useEffect(()=>{
  const screenSizeHandler=()=>{
    setScreenSize(getCurrentDimension());
  }

  window.addEventListener('resize',screenSizeHandler);

  return ()=>{
    window.removeEventListener('resize',screenSizeHandler);
  }
},[screenSize]);


  return <>
    {!isAuthenticated && <LoadingScreen />}
    <RecommendScreenSizePopup screenSize={screenSize} open={open} setOpen={setOpen} />
     {children}
     </>;
}
